<template>
    <svg fill="#000000" xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 24 24" width="24px" height="24px">    <path d="M 9 3 L 2 21 L 4 21 L 6.3320312 15 L 13.259766 15 C 13.730766 14.325 14.318188 13.737625 14.992188 13.265625 L 11 3 L 9 3 z M 10 5.5703125 L 12.888672 13 L 7.1113281 13 L 10 5.5703125 z M 19 14 C 16.239 14 14 16.239 14 19 C 14 21.761 16.239 24 19 24 C 21.761 24 24 21.761 24 19 C 24 16.239 21.761 14 19 14 z M 18 16 L 20 16 L 20 18 L 22 18 L 22 20 L 20 20 L 20 22 L 18 22 L 18 20 L 16 20 L 16 18 L 18 18 L 18 16 z"/></svg>
</template>

<script>
export default {
  name: 'Paragraph'
}
</script>